import React from "react";
import { Link } from "react-router-dom";
import { Zap, X } from "lucide-react";

/**
 * DisputeModeNudge
 *
 * Soft, dismissable upsell card surfaced when a free user types or
 * uploads something that smells like an active dispute (bond not returned,
 * eviction, tribunal hearing, breach notice). One per chat session so we
 * never nag.
 *
 * The CTA points to /pricing#dispute. Honest copy. No countdown timer
 * tricks, no "limited offer" pressure. The hearing on Thursday is the
 * pressure, we just remove the friction.
 */
export default function DisputeModeNudge({ onDismiss, variant = "chat", testid }) {
  const headline =
    variant === "upload"
      ? "Looks like a tribunal moment. Want the full toolkit?"
      : "Sounds like you're in a real dispute right now.";
  const body =
    variant === "upload"
      ? "Dispute & Tribunal Mode unlocks 30 days of deep AI, generous voice transcription, plus the evidence bundle export. Pay once. No subscription."
      : "Dispute & Tribunal Mode is $69 one-off for 30 days of everything unlocked. No subscription, no auto-renew. Built for the week you actually need it.";
  return (
    <div
      className="bg-[#FFF7F2] border-l-4 border-l-[#B35D4C] px-4 py-3 my-3 relative"
      data-testid={testid || "dispute-mode-nudge"}
      role="region"
      aria-label="Dispute Mode upsell"
    >
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="absolute top-2 right-2 text-[#B35D4C]/60 hover:text-[#B35D4C]"
          aria-label="Dismiss"
          data-testid="dispute-nudge-dismiss"
        >
          <X size={14} strokeWidth={1.75} />
        </button>
      )}
      <div className="flex items-start gap-2.5">
        <div className="w-7 h-7 bg-[#B35D4C]/10 border border-[#B35D4C]/30 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Zap size={14} strokeWidth={1.75} className="text-[#B35D4C]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-mono text-[10px] uppercase tracking-[0.12em] text-[#B35D4C] mb-0.5">
            Dispute & Tribunal Mode
          </div>
          <div className="font-serif text-[14px] text-[#0D2B52] leading-snug mb-1.5">
            {headline}
          </div>
          <p className="text-[12.5px] text-[#1A1A1A] leading-snug mb-2">{body}</p>
          <Link
            to="/pricing?upgrade=dispute#dispute-band"
            className="inline-flex items-center gap-1 text-[12px] font-mono uppercase tracking-[0.12em] text-white bg-[#B35D4C] px-3 py-1.5 hover:opacity-90"
            data-testid="dispute-nudge-cta"
          >
            See Dispute Mode →
          </Link>
        </div>
      </div>
    </div>
  );
}
